/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Line_Col_Lot_CodeInputs */

const vi_stocktake_line_col_lot_code = /** @type {(inputs: Stocktake_Line_Col_Lot_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã lô`)
};

/**

* @param {Stocktake_Line_Col_Lot_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_line_col_lot_code = /** @type {((inputs?: Stocktake_Line_Col_Lot_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Line_Col_Lot_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_line_col_lot_code(inputs)
});